import { IonButton } from "@ionic/react"
import { useContext } from "react";
import { DataContext } from '../../context/DataContext'

export const ButtonBackToSpeisekarte = () => {
  const {
    appBewohnerSollId,
    appBewohnerSollIdChange,
    appBewohnerSollBezeichnung,
    appSollReloadAuswahlChange,
    appSollReloadBestellstatusChange,
    appStation,
    appStationBezeichnung,
  } = useContext(DataContext);
  
      return (
    <IonButton
      data-sf="button_back_to_speisekarte"
      routerLink={"/speisekarte/" + appStation + "/" + appStationBezeichnung + "/" + appBewohnerSollId + "/" + appBewohnerSollBezeichnung}
      onClick={() => {
        appBewohnerSollIdChange(appBewohnerSollId);
        appSollReloadAuswahlChange(true);
        appSollReloadBestellstatusChange( true ) ;
      }}
    >
      speichern & zurück
    </IonButton>
  ) ;
}
